import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid} from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { calculateDistanceTimeFrEpoch } from '../../utils/util';
import renderHTML from 'react-render-html';
import {DeleteWhiteIcon} from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import InfiniteScroll from 'react-infinite-scroll-component';
const styles = theme => ({
    container:{
        padding: theme.spacing(6,4,4,4)
    },
    boxItemPre:{
        padding: theme.spacing(0,2,0,0)
    },
    boxItemContent: {
        padding: theme.spacing(2,4,2,4),
        marginTop: theme.spacing(2),
        //marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer'
    },
    notification_read: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        borderRadius: theme.spacing(3),
        backgroundColor: theme.palette.button.category.backgroundColor,
        shadowColor: theme.palette.background.primary,
        shadowOffset: { width: 2, height: 2 },
        shadowOpacity: 1,
        shadowRadius: 4,
        elevation: 5,
        alignSelf: 'center',
        marginLeft: theme.spacing(1)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    },
    content: {
        padding: theme.spacing(1),
        whiteSpace: 'pre-line',
    },
});
function NotificationDetailView(props) {
    const processContentWithURL = (content) =>{
        if(content) { 
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return content.replace(urlRegex, function(url) {
                return '<a target="blank" href="' + url + '">' + url + '</a>';
            })
        }
    }
    const {classes, t , item, open, onClose, showLoading} = props

    //item.content = item.content+ 'http://google.com'
    return (
            <DrawerCustom open={open} onClose={onClose} title={t('notifications')} enableBack
                children={       
                    <Grid xs={12} item>
                            <Grid item container>
                            <Grid xs={12} item className={classes.boxItemPre}>
                                <Grid item container className={classes.boxItemContent}>
                                    <Grid xs={9} sm={10} item container alignItems='center'>
                                        {item&&<CustomTypo variant={!item.is_viewed?'subtitle2':'body2'} color='primary'>{item.subject ? item.subject : ""}</CustomTypo>}
                                    </Grid>
                                    <Grid xs={3} sm={2} item container justify='flex-end' alignItems='center'>
                                        <CustomTypo color='primary'>
                                            {item&&!item.created_on ? calculateDistanceTimeFrEpoch(item.created_on) : ""}
                                        </CustomTypo>
                                            {/* <IconButton onClick={()=>props.onDeleleNotification(item.id)}><DeleteIcon/></IconButton> */}
                                    </Grid>
                                    <Grid xs={12} item className={classes.content}>
                                        {item && item.in_app_image_url&&<img src={item.in_app_image_url} style={{width:'100%'}}/>}
                {item?<CustomTypo mg_top_md variant='body2' color='primary'>{item.content ? renderHTML(processContentWithURL(item.content)) : ""}</CustomTypo>:null}
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* <Grid xs={1} item container justify='flex-end' alignItems='center'>
                                <div className={classes.bg_icon} onClick={() => props.onDeleleNotification(item.id)}>
                                    <DeleteWhiteIcon />
                                </div>
                            </Grid> */}
                        </Grid>
                
                    </Grid>
                    }
            />
    );
}

export default withStyles(styles)(withTranslation()(NotificationDetailView));